var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("action-sheet", {
        staticClass: "action-sheet",
        attrs: {
          opened: _vm.$store.state.auth.createFido.isFidoActionSheetOpen,
          title: _vm.$t(_vm.$store.state.auth.createFido.fidoActionSheetTitle),
          actionHeader: true,
          actionFooter: false,
          useTopBorder: true,
          noDimClose: true
        },
        on: {
          "update:opened": function($event) {
            return _vm.$set(
              _vm.$store.state.auth.createFido,
              "isFidoActionSheetOpen",
              $event
            )
          },
          cancel: _vm.FN001
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c(
                  "div",
                  {
                    staticClass: "access-method",
                    class: {
                      error:
                        _vm.$store.state.auth.createFido.isFidoActionSheetError
                    }
                  },
                  [
                    _vm.$store.state.native.biometryTypeIos === "faceId"
                      ? _c("i", { staticClass: "icon icon-face" })
                      : _c("i", { staticClass: "icon icon-fingerprint" })
                  ]
                ),
                _c("div", { staticClass: "access-method-info" }, [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          _vm.$store.state.auth.createFido
                            .fidoActionSheetContent
                        )
                      )
                    }
                  })
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: {
          opened: _vm.$store.state.auth.createFido.isFidoPopOpen,
          noPostivieButton: true,
          noDimClose: true,
          modalFooter: true,
          title: _vm.$store.state.auth.createFido.fidoPopTitle
        },
        on: {
          "update:opened": function($event) {
            return _vm.$set(
              _vm.$store.state.auth.createFido,
              "isFidoPopOpen",
              $event
            )
          },
          confirm: _vm.$store.state.auth.createFido.fidoPopConfirm
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(_vm.$store.state.auth.createFido.fidoPopMessage)
                    )
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("action-sheet", {
        staticClass: "action-sheet",
        attrs: {
          opened: _vm.$store.state.auth.manageFido.isFidoActShtOpen,
          title: _vm.$store.state.auth.manageFido.fidoActShtTitle,
          actionHeader: true,
          actionFooter: true,
          useTopBorder: true,
          noDimClose: true,
          noNegativeButton: _vm.$store.state.auth.manageFido.isNegativeButton,
          cancel: _vm.$store.state.auth.manageFido.fidoActShtCancelText,
          noPositiveButton: _vm.$store.state.auth.manageFido.isPositiveButton,
          confirm: _vm.$store.state.auth.manageFido.fidoActShtConfirmText
        },
        on: {
          "update:opened": function($event) {
            return _vm.$set(
              _vm.$store.state.auth.manageFido,
              "isFidoActShtOpen",
              $event
            )
          },
          cancel: _vm.$store.state.auth.manageFido.fidoActShtCancelFunction,
          confirm: _vm.$store.state.auth.manageFido.fidoActShtConfirmFunction
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("strong", { staticClass: "info-question" }, [
                  _vm.$store.state.auth.manageFido.fidoActShtContents1 !== ""
                    ? _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              _vm.$store.state.auth.manageFido
                                .fidoActShtContents1
                            )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm.$store.state.auth.manageFido.fidoActShtContents2 !== ""
                    ? _c("br")
                    : _vm._e(),
                  _vm.$store.state.auth.manageFido.fidoActShtContents2 !== ""
                    ? _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              _vm.$store.state.auth.manageFido
                                .fidoActShtContents2
                            )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm.$store.state.auth.manageFido.fidoActShtContents3 !== ""
                    ? _c("br")
                    : _vm._e(),
                  _vm.$store.state.auth.manageFido.fidoActShtContents3 !== ""
                    ? _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              _vm.$store.state.auth.manageFido
                                .fidoActShtContents3
                            )
                          )
                        }
                      })
                    : _vm._e()
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }